import * as React from "react";
const SvgKimi = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "black" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.8687 6.8883C13.9502 6.7838 14.0217 6.6883 14.0972 6.5958C14.1322 6.5523 14.1292 6.5193 14.0952 6.4738C13.7677 6.0433 13.7367 5.5653 13.9252 5.0803C14.0667 4.7153 14.3797 4.5443 14.7622 4.5078C15.0007 4.4853 15.2347 4.5098 15.4517 4.6258C15.7367 4.7783 15.9027 5.0108 15.9567 5.3318C15.9997 5.5878 15.9917 5.8378 15.9192 6.0858C15.7907 6.5248 15.4752 6.7523 15.0427 6.8098C14.6837 6.8578 14.3197 6.8638 13.9577 6.8883C13.9297 6.8903 13.9012 6.8883 13.8687 6.8883Z",
      fill: "#027AFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.981 4.92212H10.818L9.1055 8.82712H6.6845V4.93912H4.75V15.0001H6.685V10.7616H10.097C10.3852 10.7616 10.6674 10.6792 10.9104 10.5242C11.1534 10.3692 11.347 10.148 11.4685 9.88662V15.0001H13.4035V10.7616C13.4035 10.2728 13.2186 9.8021 12.8858 9.44407C12.553 9.08604 12.097 8.86724 11.6095 8.83162V8.82662H10.547C10.803 8.73916 11.0383 8.5999 11.2381 8.41753C11.4379 8.23516 11.5981 8.01359 11.7085 7.76662L12.981 4.92212Z",
      fill: "white"
    }
  )
);
export default SvgKimi;
